import { render } from "./MetadataInput.vue?vue&type=template&id=b7b69948&scoped=true&ts=true"
import script from "./MetadataInput.vue?vue&type=script&lang=ts"
export * from "./MetadataInput.vue?vue&type=script&lang=ts"

import "./MetadataInput.vue?vue&type=style&index=0&id=b7b69948&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b69948"]])

export default __exports__